import * as angular from "angular";
import {IController} from "angular";
import * as moment from "moment";
import * as _ from "lodash";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {AgentsService} from "../../services/agents-service.service";
import {AgentModel} from "../../angular/models/agent.model";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {$agentFactory} from "../../$agent.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DevicesRequestsService} from "../../../devices/services/devices-requests.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {GpsPermissionType} from "../../types/gps-permission.type";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {AgentsFacadeService} from "../../angular/state/agents-facade.service";
import {Subscription} from "rxjs";
import {AgentAuthType} from "../../types/agentAuth.type";
import {AgentType} from "../../types/agent.type";
import {AgentClientType} from "../../types/agentClient.type";
import {LocationHolderType} from "../../../commons/types/locationHolder.type";
import {LocationService} from "../../../commons/services/location-service.service";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {AgentStatusType} from "../../types/agentStatus.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {BreakType} from "../../../site-preferences/models/break-type.model";

export class AgentDetailedViewCtrl implements IController {

  agentId: string;

  public isSuperOwner: boolean;
  public agent: AgentModel;
  public openInfoSection: boolean;
  public device: any;
  public gpsPermissionType: typeof GpsPermissionType = GpsPermissionType;
  public filterAgentsByGpsEnabled: boolean;
  public agentAuthType: typeof AgentAuthType = AgentAuthType;
  private selectAgentSubscription: Subscription;
  public agentLocationAddress;
  public isLoadingAgentLastKnownLocation: boolean;
  public agentType: typeof AgentType = AgentType;
  public agentStatusType: typeof AgentStatusType = AgentStatusType;
  public agentTeamNames: string[];
  public breakDurationMinutes: number;

  constructor(private $log, private $mdSidenav, private $agent: $agentFactory, private bringozLoaderService: BringozLoaderService, private commonsDialogService: CommonsDialogService,
              private agentsService: AgentsService, private agentDialogService: AgentDialogService, private devicesRequestsService: DevicesRequestsService,
              private agentsAlerts: AgentsAlerts, private commonsService: CommonsService, private siteContextService: SiteContextService, private $timeout,
              private commonsAlertsService: CommonsAlertsService, private analyticsService: AnalyticsService, private agentsFacadeService: AgentsFacadeService,
              private locationService: LocationService, private latLngToAddress, private IAMPermissions: IAMPermissionsService, private $state,
              private splitService: SplitService) {
  }

  $onInit() {
    this.isSuperOwner = this.IAMPermissions.hasRole('super.owner');

    this.openInfoSection = false;
    this.filterAgentsByGpsEnabled = this.siteContextService.getSiteInfo().filterAgentsByGpsEnabled;

    this.agentsFacadeService.subscribeToChannels([this.agentId]);
    // Select Account
    this.selectAgentSubscription = this.agentsFacadeService.selectOne(this.agentId)
      .subscribe(agent => {
        if (!!agent) {
          this.agent = angular.copy(agent);
          this._setBreakDuration();

          this.agentTeamNames = agent.teamReferences?.map(t => t.name) || [];

          // Update Angularjs Cycle
          this.$timeout(0).then(() => {
          });
        }
      });

    // Subscribe Account
    this.agentsFacadeService.subscribeToChannels();
  };

  $onDestroy() {
    this.selectAgentSubscription.unsubscribe();
    this.agentsFacadeService.unsubscribeFromChannels();
  }

  onToggleMoreInfo() {
    this.openInfoSection = !this.openInfoSection;
    if (!!this.openInfoSection) {
      this._getDeviceData();
    }
  }

  openEditInfo(event) {
    let loading = false;
    this.agentDialogService.editAgent(event, this.agent, false)
      .then((payload: { agent: AgentModel, autoStopRecordingIntervalMinutes?: boolean }) => {
        this.analyticsService.trackEvent('Agents Actions', 'Edit Info', 'Confirm');
        loading = true;
        this.bringozLoaderService.on();
        return this.$agent(this.agent.id).$update(payload.agent, undefined, {autoStopRecordingIntervalMinutes: payload.autoStopRecordingIntervalMinutes})
      })
      .then((updatedAgent) => {
        this.agent = updatedAgent;
        this._setBreakDuration();
        this.agentsAlerts.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.updateError(error);
          this.$log.info('Failed to update agent', error);
          this.analyticsService.trackEvent('Agents Actions', 'Edit Info', 'Error');
        } else {
          this.$log.info('Dialog Closed');
          this.analyticsService.trackEvent('Agents Actions', 'Edit Info', 'Cancel');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  openEditExternalId() {
    this.commonsDialogService.editExternalId(this.agent.externalId)
      .then((externalId) => {
        const agentCopy = angular.copy(this.agent);
        agentCopy.externalId = externalId
        this.agentsService.updateAgentExternalId(agentCopy).then((agent) => {
          this.agent = agent;
          this._setBreakDuration();
        });
      })
  }

  toggleSidenav(event) {
    this.$mdSidenav('closeEventsDisabled').toggle();
  }

  openEditPassword(event) {
    const email = this.agent.user?.email;
    this.commonsDialogService.editPassword(email, event)
      .then((editedPassword) => {
        this.updateAgentPassword(this.agent.id, editedPassword)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  collapseInfoSection(event) {
    event.stopPropagation();
    this.openInfoSection = !this.openInfoSection;
  }

  onSendNotificationToAgent(agentPnType: string) {
    this.agentsService.sendNotification(agentPnType, [this.agent.id]);
  }

  private _getDeviceData() {
    this.devicesRequestsService.getDevices(this.agent.id)
      .then((devices) => {
        this.device = devices.reduce((prev, current) => {
          return current.updatedAt > prev.updatedAt ? current : prev;
        });
      })
      .catch((error) => {
        this.$log.error('Failed to get devices by agent @agentDetailedView@ctrl.$onInit', error);
      })
      .finally(() => {
      })
  }

  private updateAgentPassword(agentId: string, editedPassword: string) {
    this.agentsService.updatePassword(agentId, editedPassword)
      .then((updatedAgent) => {
        this.$log.debug(updatedAgent);
      })
  }

  // Active break type duration (timekeeping) takes precedence over the configuration profile break duration
  private _setBreakDuration() {
    const breakType: BreakType = _.find(this.splitService.getBreakTypes(), {id: this.agent.activeBreakTypeId});
    this.breakDurationMinutes = breakType ? breakType.durationMinutes : this.agent.breakDurationMinutes;
  }

  onUpdatedAgent(agent: AgentModel) {
    this.agent = agent;
    this._setBreakDuration();
  }

  onChangeArchiveStatus() {
    const agentCopy = angular.copy(this.agent);
    agentCopy.isArchive = false;
    this.agentsService.changeArchiveStatus(this.agent.id, agentCopy)
      .then((updatedAgent) => {
        this.$log.debug(updatedAgent);
      })
  }

  onPasswordLess(authType: AgentAuthType) {
    const client = this.agent.agentType === AgentType.Driver ? AgentClientType.Driver : AgentClientType.Workforce;
    this.agentsService.passwordless(this.agentId, authType, client)
      .then((res) => {

      })
  }

  getLocation() {
    this.agentLocationAddress = {};
    if (this.agent.lastKnownLocation?.coordinates?.latitude && this.agent.lastKnownLocation?.coordinates?.longitude) {
      this._setLocationAddress(this.agent.lastKnownLocation?.coordinates);
    } else if (this.agentId) {
      this._setAgentLocation();
    }
  }

  onDeleteAvatar() {
    const agentPayload = angular.copy(this.agent);
    agentPayload.user.avatarUrl = undefined;
    this.$agent(this.agent.id).$update(agentPayload);
  }

  private _setAgentLocation() {
    const payload = {
      holderId: this.agentId,
      holder: LocationHolderType.Agent
    }

    this.isLoadingAgentLastKnownLocation = true;
    this.locationService.getLocations([payload])
      .then((locations: any) => {
        this._setLocationAddress(locations[0].coordinates);
      })
      .finally(() => {
        this.isLoadingAgentLastKnownLocation = false;
      })
  }

  private _setLocationAddress(location) {
    this.isLoadingAgentLastKnownLocation = true;
    this.latLngToAddress(location.latitude, location.longitude)
      .then((place) => {
        this.agentLocationAddress = {
          lat: location.lat,
          lng: location.lng,
          place: place
        };
      })
      .finally(() => {
        this.isLoadingAgentLastKnownLocation = false;
      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentDetailedView', {
    bindings: {
      agentId: '<'
    },
    template: require('./agent-detailed-view.html').default,
    controller: AgentDetailedViewCtrl
  });
